// extracted by mini-css-extract-plugin
export default {"visionCard":"Card_visionCard__7eEXg","header":"Card_header__C-eJo","valuesCard":"Card_valuesCard__bby57"};